/**
 * The one reader of a tenant's block switches on the storefront
 * (KAN-1635, KAN-1636): every public page asks it whether a block of its
 * own renders. Switches arrive with the branding the page already loads.
 */

import { useTenantBranding } from "@/api/queries/branding";
import {
  isBlockVisible,
  type PageBlockKey,
  type PageWithBlocks,
} from "@/shell/toggleablePages";

export function usePageBlocks<P extends PageWithBlocks["key"]>(
  page: P,
): (block: PageBlockKey<P>) => boolean {
  const branding = useTenantBranding();
  const blocks = branding.data?.site_appearance?.blocks;
  return (block) => isBlockVisible(blocks, page, block);
}
